import clsx from 'clsx'
import {toAbsoluteUrl} from '../../../../helpers'
import {HeaderUserMenu} from '../../../../partials'
import {useAuth} from '../../../../../app/modules/auth'
import {useEffect, useMemo, useState} from 'react'
import {getFranchises} from '../../../../../pages/chooseFranchise/core/_request'
import {MenuComponent} from '../../../../assets/ts/components'
import {HeaderNotificationsMenuNav} from '../../../components/header/header-menus/HeaderNotifications'

const itemClass = 'ms-1 ms-md-4'
const userAvatarClass = 'symbol-35px'

const Navbar = () => {
  const [loadingPage, setLoadingPage] = useState(false)
  const {currentUser, currentFranchise} = useAuth()
  const [franchises, setFranchises] = useState([])

  const DEFAULT_AVATAR = '/media/svg/avatars/blank.svg'
  const API_URL = process.env.REACT_APP_API_URL + '/api/profile/photo'
  const [avatarPreview, setAvatarPreview] = useState<string>(() => {
    return currentUser?.profilePhoto ? API_URL : toAbsoluteUrl(DEFAULT_AVATAR)
  })

  useEffect(() => {
    async function init() {
      try {
        setLoadingPage(true)
        const franchises = await getFranchises()
        setFranchises(franchises)
      } catch (error: any) {
        setFranchises([])
        if (error?.handled) return
      } finally {
        setLoadingPage(false)
      }
    }
    init()
  }, [currentUser])

  MenuComponent.reinitialization()

  return (
    <>
      <div className='app-navbar flex-shrink-0'>
        <div className={clsx('app-navbar-item', itemClass)}>
          <div className='d-none d-md-flex flex-column'></div>
          <div
            className={clsx('cursor-pointer symbol', userAvatarClass)}
            data-kt-menu-trigger="{default: 'click'}"
            data-kt-menu-attach='parent'
            data-kt-menu-placement='bottom-end'
          >
            <img src={avatarPreview} alt='' />
          </div>
          <HeaderUserMenu />
        </div>
      </div>
    </>
  )
}

export {Navbar}
